function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 20,
  r: 20,
  fill: "url(#course-admin-tab-demo_svg__paint0_linear_574_12815)"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.21 30.58L20.63 40c10.967-.064 19.805-8.903 19.87-19.87l-9.42-9.42-19.87 19.87z",
  fill: "#000"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.177 10.322H12.113c-.71 0-1.29.58-1.29 1.29v18.065c0 .71.58 1.29 1.29 1.29H24.37l7.097-7.096V11.613c0-.71-.581-1.29-1.29-1.29z",
  fill: "#FFFCF2"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.371 23.871v7.097l7.097-7.097H24.37zm-9.677 2.581h7.096v-1.29h-7.096v1.29zm12.258-5.161H14.694v1.29h12.258v-1.29zm0-3.871H14.694v1.29h12.258v-1.29zm-2.581-3.871h-9.677v1.29h9.677v-1.29z",
  fill: "#D4DAE1"
});
var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "course-admin-tab-demo_svg__paint0_linear_574_12815",
  x1: 0.5,
  y1: 40,
  x2: 42.736,
  y2: 2.519,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#009AC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.607,
  stopColor: "#00CCBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#60F3AB"
})));
function SvgCourseAdminTabDemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}
export default __webpack_public_path__ + "fonts/course-admin-tab-demo-1d4c8ff1bfa6c90370695b9546996da4.svg";
export { SvgCourseAdminTabDemo as ReactComponent };